module.exports = __webpack_public_path__ + "img/69dc734.png";